const API = require('common/infra/api/app-info');
const AppInfo = require('common/domain/entity/app-info');

class Repository {
    constructor() {
        this._appInfoPromise = null;
    }

    get() {
        if(this._appInfoPromise) {
            return this._appInfoPromise;
        }
        this._appInfoPromise = new Promise((resolve, reject) => {
            API.get().then(appInfoJson => {
                resolve(new AppInfo(appInfoJson));
            }, reject);
        });

        return this._appInfoPromise;
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./common/domain/repository/app-info.js